import { Splide } from "@splidejs/splide";


const carousel = () => {
  const targetElms = document.getElementsByClassName('js-sliderBasic');
  if(targetElms.length === 0) return;
  for(const targetElm of targetElms) {
    const speed = 1500;
    let options = {
      type: "slide",
      speed: speed,
      rewindSpeed: speed,
      autoWidth: true,
      interval: 3000,
      gap: "0.5rem",
      arrows: false,
      pagination: false,
      autoplay: true,
      reduceMotion: {
        speed: speed,
        rewindSpeed: speed,
      }
    }
    if(targetElm.dataset.speed) {
      options.speed = parseInt(targetElm.dataset.speed);
      options.rewindSpeed = parseInt(targetElm.dataset.speed);
      options.reduceMotion.speed = parseInt(targetElm.dataset.speed);
      options.reduceMotion.rewindSpeed = parseInt(targetElm.dataset.speed);
    }

    if(targetElm.dataset.gap) {
      options.gap = targetElm.dataset.gap;
    }

    if(targetElm.dataset.gapSp) {
      options.breakpoints = {
        768: {
          gap: targetElm.dataset.gapSp,
        }
      };
    }

    if(targetElm.dataset.arrows === "true") {
      options.arrows = true;
    }

    if(targetElm.dataset.pagination === "true") {
      options.pagination = true;
    }

    if(targetElm.dataset.loop === "true") {
      options.type = "loop";
    }

    if(targetElm.dataset.clones) {
      options.clones = parseInt(targetElm.dataset.clones);
    }

    if(targetElm.dataset.center === "true") {
      options.focus = 'center';
    }

    const slider = new Splide(targetElm, options);
    slider.mount();
    targetElm._splide = slider;
  }
}

const carouselSP = () => {
  const SP_BREAKPOINT = 768;
  const targetElms = document.getElementsByClassName('js-sliderSP');
  if(targetElms.length === 0) return;

  const mql = window.matchMedia(`(max-width: ${SP_BREAKPOINT - 1}px)`);

  const handleBreakpoint = (e) => {
    for(const targetElm of targetElms) {
      if(e.matches) {
        // SP: マウント
        if(!targetElm._splide) {
          const speed = 1500;
          let options = {
            type: "slide",
            speed: speed,
            rewindSpeed: speed,
            autoWidth: true,
            interval: 3000,
            gap: "0.5rem",
            arrows: false,
            pagination: false,
            autoplay: true,
            reduceMotion: {
              speed: speed,
              rewindSpeed: speed,
            }
          }
          if(targetElm.dataset.gap) {
            options.gap = targetElm.dataset.gap;
          }
          if(targetElm.dataset.arrows === "true") {
            options.arrows = true;
          }
          if(targetElm.dataset.pagination === "true") {
            options.pagination = true;
          }
          if(targetElm.dataset.loop === "true") {
            options.type = "loop";
          }
          if(targetElm.dataset.clones) {
            options.clones = parseInt(targetElm.dataset.clones);
          }
          if(targetElm.dataset.center === "true") {
            options.focus = 'center';
          }
          const slider = new Splide(targetElm, options);
          slider.mount();
          targetElm._splide = slider;
        }
      } else {
        // PC: デストロイ
        if(targetElm._splide) {
          targetElm._splide.destroy();
          targetElm._splide = null;
        }
      }
    }
  }

  mql.addEventListener('change', handleBreakpoint);
  handleBreakpoint(mql);
}

const init = () => {
  carousel();
  carouselSP();
}
export default init;